import React from 'react';

const hasValidationErrors = (errors: Record<string, string | React.ReactNode>) => {
  let hasValidationError = false;
  Object.keys(errors).forEach(errorKey => {
    const value = errors[errorKey];
    if (typeof value === 'string' && value.length > 0) {
      hasValidationError = true;
    }
    if (React.isValidElement(value)) {
      hasValidationError = true;
    }
  });
  return hasValidationError;
};

export default hasValidationErrors;
